//TODO: MAKE ALL ENVIRONMENT VARS DRIVEN BY BUILD SCRIPT + CENTRAL BUILD CONFIG

/*eslint no-unused-vars: 0 */
//const dev_env = 'https://localhost.abbvienet.com:10001';
//const test_env = 'https://dreamland.abbvienet.com:10005';
//const prod_env = 'https://stormcloud.abbvienet.com:10005';

export const cur_env = process.env.REACT_APP_DATA_SERVICE;
//console.log(process);
//console.log(cur_env);

//TODO: Document service params and opts here as well
export const fetch_page_data_url = cur_env + '/DupeSearchServices/getPageData';

export const fetch_unique_multiselect_filter_opts = cur_env + '/DupeSearchServices/getUniqueFieldValues';

//services for getting the detail views
export const get_adverse_event_data_url = cur_env + '/DupeSearchServices/getAdverseEventData';

export const get_reporter_data_url = cur_env + '/DupeSearchServices/getReporterData';

export const get_source_data_url = cur_env + '/DupeSearchServices/getSourceData';

export const get_product_data_url = cur_env + '/DupeSearchServices/getProductData';



// WEBPACK FOOTER //
// ./src/Utility/DataSources.js